<template>
  <div class="promotion">
    <div class="promotion-content">
      <Header />

      <div class="document">
        <div class="document-title">
          <img src="@assets/promotion/flow.png" alt="" />
          业务流程图
        </div>
        <img class="flow-img" src="@assets/promotion/flow-img.jpg" alt="" />

        <div class="document-title">
          <img src="@assets/promotion/api.png" alt="" />
          API 文档
        </div>
        <div class="document-api">
          <a target="_blank" href="https://vop.vip.com/home;jsessionid=F2978DB45C76EFC05ED7EF75F3DF5227#/api/method/detail/com.vip.wpc.ospservice.vop.WpcVopOspService-1.0.0">点击进入查看 ></a>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/PromotionHeader.vue'
import Footer from '@/components/PromotionFooter.vue'
import util from '@/utils'

export default {
  name: 'promotion-document',
  components: {
    Header,
    Footer,
  },
  created() {
    util.setPCHtmlFontSize()

    this.$tracker.page('wdg_page_official_website', {
      page_id: 2 // document 文档中心
    })
  },
}
</script>

<style lang="stylus" scoped>
.promotion {
  width: 100%;
  min-width: 1000px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;

  .promotion-content {
    min-height: calc(100vh - 80rem);
  }

  .document {
    width: 1200rem;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 70rem 20rem 100rem;
    .document-title {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 32rem;
      img {
        width: 50rem;
        height: 50rem;
        margin-right: 15rem;
      }
    }
    .flow-img {
      display: block;
      margin: 70rem auto 80rem;
      width: 1000rem;
      height: auto;
    }

    .document-api {
      margin-top: 10rem;
      margin-left: 55rem;
      cursor: pointer;
      a {
        font-size: 28rem;
        color: #0091FF;
        text-decoration: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/promotion-document.vue